module.exports = __webpack_public_path__ + "img/shop_haier_bottom.eda50467.png";